import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  MoreVerticalIcon,
  UserCircleIcon,
  Logout01Icon,
  Sun01Icon,
  Moon02Icon,
  HelpCircleIcon,
  Shield02Icon,
  File02Icon
} from '@hugeicons/core-free-icons';
import { useAuth } from '../contexts/AuthContext';
import ResponsiveModal from './ResponsiveModal';
import { api } from '../utils/api';

const MobileMenu = ({ toggleTheme, isDark }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Logout request failed:', error);
    } finally {
      logout();
      navigate('/login');
    }
  };

  return (
    <div className="flex lg:hidden">
      <button 
        onClick={() => setIsOpen(true)}
        className="p-2 rounded-full text-muted-gray hover:bg-off-white/80 dark:hover:bg-dark-surface/50 transition-colors"
      >
        <HugeiconsIcon icon={MoreVerticalIcon} size={20} className="text-charcoal dark:text-white" />
      </button>

      <ResponsiveModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title=""
      >
        <div className="py-2 space-y-3">
          <Link 
            to="/profile" 
            onClick={() => setIsOpen(false)}
            className="flex items-center gap-4 p-4 rounded-2xl bg-off-white/50 dark:bg-gray-800/50 hover:bg-soft-green/10 transition-colors group"
          >
            <div className="bg-gray-200 dark:bg-gray-700 p-2 rounded-xl group-hover:bg-soft-green/20">
              <HugeiconsIcon icon={UserCircleIcon} size={20} className="text-muted-gray group-hover:text-soft-green" />
            </div>
            <span className="font-bold text-charcoal dark:text-white">Profile</span>
          </Link>

          <Link 
            to="/support" 
            onClick={() => setIsOpen(false)}
            className="flex items-center gap-4 p-4 rounded-2xl bg-off-white/50 dark:bg-gray-800/50 hover:bg-soft-green/10 transition-colors group"
          >
            <div className="bg-gray-200 dark:bg-gray-700 p-2 rounded-xl group-hover:bg-soft-green/20">
              <HugeiconsIcon icon={HelpCircleIcon} size={20} className="text-muted-gray group-hover:text-soft-green" />
            </div>
            <span className="font-bold text-charcoal dark:text-white">Help & Support</span>
          </Link>

          <Link 
            to="/privacy-policy" 
            onClick={() => setIsOpen(false)}
            className="flex items-center gap-4 p-4 rounded-2xl bg-off-white/50 dark:bg-gray-800/50 hover:bg-soft-green/10 transition-colors group"
          >
            <div className="bg-gray-200 dark:bg-gray-700 p-2 rounded-xl group-hover:bg-soft-green/20">
              <HugeiconsIcon icon={Shield02Icon} size={20} className="text-muted-gray group-hover:text-soft-green" />
            </div>
            <span className="font-bold text-charcoal dark:text-white">Privacy Policy</span>
          </Link>

          <Link 
            to="/terms-of-service" 
            onClick={() => setIsOpen(false)}
            className="flex items-center gap-4 p-4 rounded-2xl bg-off-white/50 dark:bg-gray-800/50 hover:bg-soft-green/10 transition-colors group"
          >
            <div className="bg-gray-200 dark:bg-gray-700 p-2 rounded-xl group-hover:bg-soft-green/20">
              <HugeiconsIcon icon={File02Icon} size={20} className="text-muted-gray group-hover:text-soft-green" />
            </div>
            <span className="font-bold text-charcoal dark:text-white">Terms of Service</span>
          </Link>

          <button 
            onClick={() => { toggleTheme(); setIsOpen(false); }}
            className="w-full flex items-center gap-4 p-4 rounded-2xl bg-off-white/50 dark:bg-gray-800/50 hover:bg-soft-green/10 transition-colors group"
          >
            <div className="bg-gray-200 dark:bg-gray-700 p-2 rounded-xl group-hover:bg-soft-green/20">
              <HugeiconsIcon icon={isDark ? Sun01Icon : Moon02Icon} size={20} className="text-muted-gray group-hover:text-soft-green" />
            </div>
            <span className="font-bold text-charcoal dark:text-white">{isDark ? 'Light Mode' : 'Dark Mode'}</span>
          </button>

          <button 
            onClick={handleLogout}
            className="w-full flex items-center gap-4 p-4 rounded-2xl bg-red-50 dark:bg-red-900/10 hover:bg-red-100 dark:hover:bg-red-900/20 transition-colors group"
          >
            <div className="bg-red-100 dark:bg-red-800/30 p-2 rounded-xl group-hover:bg-red-200 dark:group-hover:bg-red-800/50">
              <HugeiconsIcon icon={Logout01Icon} size={20} className="text-red-500 group-hover:text-red-600" />
            </div>
            <span className="font-bold text-red-600 dark:text-red-400">Logout</span>
          </button>
        </div>
      </ResponsiveModal>
    </div>
  );
};

export default MobileMenu;
